<dspx-dialog (onSubmit)="dialogSubmitted($event)"></dspx-dialog>
<h1>Concession Claim</h1>
<p-card>
  <h2><strong>Select a concession:</strong></h2>
  <p-accordion class="w-full" [multiple]="true">
    <p-accordionTab [selected]="isExpanded">
      <ng-template pTemplate="header">
        <span class="flex align-items-center gap-2 w-full">
          <span class="font-bold white-space-nowrap">
            Non-Mains Water Concession
          </span>
        </span>
      </ng-template>
      <button pButton
              pRipple
              type="button"
              class="p-button-rounded p-button-outlined"
              label="Start Application"
              title="Start Application"
              icon="pi pi-send"
              (click)="startNMWCpplication()"
              id="startNMWCpplication">
      </button>
    </p-accordionTab>

    <p-accordionTab [selected]="isExpanded">
      <ng-template pTemplate="header">
        <span class="flex align-items-center gap-2 w-full">
          <span class="font-bold white-space-nowrap">
            Non-Mains Energy Concession
          </span>
        </span>
      </ng-template>
      <button pButton
              pRipple
              type="button"
              class="p-button-rounded p-button-outlined"
              label="Start Application"
              title="Start Application"
              icon="pi pi-send"
              (click)="startNMECApplication()"
              id="startNMECApplication">
      </button>
    </p-accordionTab>

    <p-accordionTab [selected]="isExpanded">
      <ng-template pTemplate="header">
        <span class="flex align-items-center gap-2 w-full">
          <span class="font-bold white-space-nowrap">
            Non-Mains Medical Cooling Concession
          </span>
        </span>
      </ng-template>
      <button pButton
              pRipple
              type="button"
              class="p-button-rounded p-button-outlined"
              label="Start Application"
              title="Start Application"
              icon="pi pi-send"
              (click)="startNMMCCApplication()"
              id="startNMMCCApplication">
      </button>
    </p-accordionTab>

    <p-accordionTab [selected]="isExpanded">
      <ng-template pTemplate="header">
        <span class="flex align-items-center gap-2 w-full">
          <span class="font-bold white-space-nowrap">
            Non-Mains Life Support Concession
          </span>
        </span>
      </ng-template>
      <button pButton
              pRipple
              type="button"
              class="p-button-rounded p-button-outlined"
              label="Start Application"
              title="Start Application"
              icon="pi pi-send"
              (click)="startNMLSCApplication()"
              id="startNMLSCApplication">
      </button>
    </p-accordionTab>

    <p-accordionTab [selected]="isExpanded">
      <ng-template pTemplate="header">
        <span class="flex align-items-center gap-2 w-full">
          <span class="font-bold white-space-nowrap">
            EDA and POW Gold Card Municipal Rates Concession
          </span>
        </span>
      </ng-template>
      <button pButton
              pRipple
              type="button"
              class="p-button-rounded p-button-outlined"
              label="Start Application"
              title="Start Application"
              icon="pi pi-send"
              (click)="startEDAPOWApplication()"
              id="startEDAPOWApplication">
      </button>
    </p-accordionTab>
  </p-accordion>
</p-card>
